import { FetchResult } from 'apollo-link';
import { DataProxy } from 'apollo-cache';

import {
  FeedByUser,
  FeedKey,
  Group,
  PaginatedUserFeedFollows,
  UserProfile,
  GetCurrentUserFeedDocument,
  GetFollowedDocument,
  GroupRole,
} from 'api';
import { FOLLOW_QUERIES_LIMIT, NULL } from 'constants/index';

interface IGroupCreateOptions {
  currentUser: UserProfile;
}

interface IAddFollow {
  getPaginatedUserFeedFollows: PaginatedUserFeedFollows;
  user: UserProfile;
  group: Group;
}

interface IAddModerator {
  getByUserFeed: FeedByUser;
  group: Group;
}

function addFollow({ getPaginatedUserFeedFollows, user, group }: IAddFollow) {
  const { feed_follows } = getPaginatedUserFeedFollows;

  const follow = {
    group,
    created_at: Date.now(),
    feed: FeedKey.Group,
    postable: true,
    user: NULL,
    user_id: user.id,
    followed_by_user: NULL,
    group_role: GroupRole.Owner,
    required: false,
    __typename: 'UserFeedFollow',
  };

  feed_follows.push(follow);
}

function addModerator({ getByUserFeed, group }: IAddModerator) {
  const { user } = getByUserFeed;

  if (!user.group_moderator) {
    user.group_moderator = [];
  }

  const moderator = {
    client_id: user.client_id,
    group_id: group.id,
    user_id: user.id,
    created_at: Date.now(),
    added_by_user_id: user.id,
    user: NULL,
    __typename: 'GroupModerator',
  };

  user.group_moderator.push(moderator);
}

type GroupCreate = [DataProxy, FetchResult, IGroupCreateOptions];

export const groupCreate = (...args: GroupCreate) => {
  const [cache, mutationResult, options] = args;
  const { currentUser } = options;
  const { createGroup } = mutationResult.data;

  const followedCacheOptions = {
    query: GetFollowedDocument,
    variables: { data: { user_id: currentUser.id, limit: FOLLOW_QUERIES_LIMIT } },
  };
  const userFeedCacheOptions = {
    query: GetCurrentUserFeedDocument,
    variables: { user_id: currentUser.id },
  };

  const { getPaginatedUserFeedFollows } = cache.readQuery(followedCacheOptions);
  const { getByUserFeed } = cache.readQuery(userFeedCacheOptions);

  addModerator({ getByUserFeed, group: createGroup });
  addFollow({ getPaginatedUserFeedFollows, user: currentUser, group: createGroup });

  cache.writeQuery({
    data: { getPaginatedUserFeedFollows },
    ...followedCacheOptions,
  });
  cache.writeQuery({
    data: { getByUserFeed },
    ...userFeedCacheOptions,
  });
};
